import React from "react";
import { Box, Paper, Typography } from "@material-ui/core";
import useStyles from "./styles";
import KnownAttribute from "./KnownAttribute";
import { useIntl } from "react-intl";
import messages from "./messages";
import SecuredComponent from "../../../redux/keyclock/SecuredComponent/SecuredComponent";

interface IStepAttributeMainProps {
}

const StepAttributeMain: React.FC<IStepAttributeMainProps> = ({ }) => {
    const classes = useStyles();

    // translations
    const intl = useIntl();
    const transTypoReferenceUnit = intl.formatMessage({ ...messages.typoReferenceUnit });
    const transTypoLevel = intl.formatMessage({ ...messages.typoLevel });

    return (
        <Paper className={classes.paper}>

            <Box mt={0}>
                <Typography variant="body2" className={classes.fieldset}>
                    {transTypoReferenceUnit}
                </Typography>
                <SecuredComponent permission={{resource: "mapping", scope: "mapping:update", isProject: true}}>
                    <KnownAttribute name={"reference"}/>
                </SecuredComponent>
            </Box>
            <Box mt={1}>
                <Typography variant="body2" className={classes.fieldset}>
                    {transTypoLevel}
                </Typography>
                <SecuredComponent permission={{resource: "mapping", scope: "mapping:update", isProject: true}}>
                    <KnownAttribute name={"level"}/>
                </SecuredComponent>
            </Box>
        </Paper>
    );
};

export default StepAttributeMain;